/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-12",
    versionChannel: "nightly",
    buildDate: "2025-05-12T00:07:03.897Z",
    commitHash: "a6d975112c5a1e89071882145a8c77b7c970973f",
};
